import { render, staticRenderFns } from "./PazienteAttivita.vue?vue&type=template&id=384569a0"
import script from "./PazienteAttivita.vue?vue&type=script&lang=js"
export * from "./PazienteAttivita.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports